import React, {useState, useEffect, useCallback} from 'react';
import {Row, Col} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
// import {loadUser, logoutUser} from '@store/reducers/auth';
import {MainLoader} from '@components';

import HeaderNoSidebar from '@modules/layouts/header/HeaderNoSidebar';
import Footer from '@modules/layouts/footer/FooterMain';
import {StyledH1, WhiteButton} from '@app/Styled/index';

const ReporterDashboard = () => {
  const [isAppLoaded, setIsAppLoaded] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const bodyEl = document.getElementsByTagName('body')[0];
    document.getElementById('root').classList.remove('hold-transition');
    document.getElementById('root').classList.remove('login-page');

    bodyEl.classList.add('layout-fixed');
    setIsAppLoaded(true);

    return () => {
      bodyEl.classList.remove('layout-fixed');
    };
  }, []);

  const handleToggleMenuSidebar = () => {
    // empty not required
  };

  const handleGotoPortal = () => {
    history.push('/activities');
  };

  const getAppTemplate = useCallback(() => {
    if (!isAppLoaded) {
      return <MainLoader />;
    }
    return (
      <>
        <HeaderNoSidebar />
        <div className="content-wrapper" style={{marginLeft: '0px'}}>
          <div className="pt-3 pt-lg-0" />
          <section className="content px-0">
            <div className="reporter-about-hero-container px-5 px-lg-0">
              <div className="mr-5">
                <StyledH1 style={{fontSize: '60px', lineHeight: 1}}>
                  CCE
                  <br />
                  Data Portal
                </StyledH1>
                <p>Start Reporting Emissions</p>
              </div>
              <div>
                <WhiteButton
                  style={{width: '150px'}}
                  onClick={handleGotoPortal}
                >
                  Start
                </WhiteButton>
              </div>
            </div>
            <Row className="no-gutters" style={{backgroundColor: '#fff'}}>
              <Col xs={12} lg={4}>
                <div className="card reporter-about-card mx-auto mt-3">
                  <div className="card-body">Info Card 1</div>
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className="card  reporter-about-card mx-auto mt-3">
                  <div className="card-body">Info Card 2</div>
                </div>
              </Col>
              <Col xs={12} lg={4}>
                <div className="card  reporter-about-card mx-auto mt-3">
                  <div className="card-body">Info Card 3</div>
                </div>
              </Col>
            </Row>
          </section>
        </div>
        <Footer />
        <div
          id="sidebar-overlay"
          role="presentation"
          onClick={handleToggleMenuSidebar}
          onKeyDown={() => {}}
        />
      </>
    );
  }, [isAppLoaded]);

  return <div className="wrapper">{getAppTemplate()}</div>;
};

export default ReporterDashboard;
